import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const CurrentUserProfileComponent = loadable(
  () => import("../../components/User/CurrentUserProfile")
);

const UserProfile = () => {
  const { data: profile } = useGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <StatusIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>My Profile</span>
      </div>
      <CurrentUserProfileComponent profile={profile} />
    </>
  );
};

export default UserProfile;
